import { msg } from '@lingui/macro'

export const granteeReportFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Type__c: 'type',
  FGM_Base__Due_Date__c: 'dueDate',
  Survey__c: 'surveyId',
  RecordTypeId: 'recordTypeId',
  Budget_changes__c: 'hasBudgetChanged',
  RecordType: {
    fieldName: 'recordType',
    Name: 'name',
    DeveloperName: 'developerName'
  },
  Form__c: 'form',
  FGM_Base__Request__c: 'opportunity',
  FGM_Base__Type__c: 'scope',
  FGM_Base__Status__c: 'status',
  FGM_Base__Submission_Date__c: 'submissionDate',
  FGM_Base__Submitted_By__c: 'submittedBy',
  Submitted_using_survey__c: 'wasSubmittedUsingSurvey',
  Submitted_Manually__c: 'submittedManually'
}

export interface GranteeReport {
  id: string
  type: 'Interim' | 'Final report' | 'Feasibility report'
  opportunity: string
  recordTypeId: string
  dueDate: Date
  wasSubmittedUsingSurvey?: boolean
  submittedManually?: boolean
  status: 'Scheduled' | 'Requested' | 'Submitted' | 'More info required' | 'Approved' | 'Rejected' | 'Obsolete'
}

export interface sfGranteeReport {
  Id: string
  Type__c: string
  FGM_Base__Due_Date__c: string
  Survey__c: string
  RecordTypeId: string
  Budget_changes__c: string
  RecordType: {
    fieldName: string
    Name: string
    DeveloperName: string
  }
  Form__c: string
  FGM_Base__Request__c: string
  FGM_Base__Type__c: string
  FGM_Base__Status__c: string
  FGM_Base__Submission_Date__c: string
  FGM_Base__Submitted_By__c: string
  Submitted_using_survey__c: string
}

export const GRANTEE_REPORT_TYPES = {
  SCHEDULED: 'Scheduled',
  REQUESTED: 'Requested',
  SUBMITTED: 'Submitted',
  MORE_INFO_REQUIRED: 'More info required',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  OBSOLETE: 'Obsolete'
}

export const GRANTEE_REPORT_STATUS_TRANSLATIONS = {
  Scheduled: msg`SF_API_Scheduled`,
  Requested: msg`SF_API_Requested`,
  Submitted: msg`SF_API_Submitted`,
  'More info required': msg`SF_API_More_info_required`,
  Approved: msg`SF_API_Approved`,
  Rejected: msg`SF_API_Rejected`,
  Obsolete: msg`SF_API_Obsolete`
}
